(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-videos-thumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var thumbnail = event.target.closest('.custom-videos .product--video__thumbnail');
    if (thumbnail) {
      var videoIndex = thumbnail.getAttribute('data-index');
      if (!videoIndex) return;

      document.querySelectorAll('.product--video__overlay').forEach(function (overlay) {
        overlay.classList.add('visible');
      });

      var insert = document.querySelector(".product--video__insert[data-index='" + videoIndex + "']");
      if (!insert) return;

      insert.classList.add('visible');
      insert.querySelectorAll('video').forEach(function (video) {
        video.play();
      });
      return;
    }

    if (!event.target.closest('.product--video__overlay.visible')) return;

    document.querySelectorAll('.product--video__overlay').forEach(function (overlay) {
      overlay.classList.remove('visible');
    });
    document.querySelectorAll('.product--video__insert.visible').forEach(function (insert) {
      insert.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
      insert.classList.remove('visible');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-videos-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var trigger = event.target.closest('.product-videos-accordion .js-accordion-trigger');
    if (!trigger) return;

    var accordion = trigger.closest('.product-videos-accordion');
    var innerWrapper = accordion && accordion.querySelector('.product-accordion__content-inner');
    if (!innerWrapper) return;

    innerWrapper.closest('.product-accordion__item').style.setProperty(
      '--content-height',
      innerWrapper.offsetHeight + 'px',
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shade-selector-modal"] && !Shopify.designMode) return;
  try {
    function initShadeSelector() {
    var shadeSelector = document.querySelector('.shade-selector-modal__wrapper');

    if (!shadeSelector) return;

    shadeSelector.querySelectorAll('label.ColorSwatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        shadeSelector.querySelectorAll('.selected-swatch').forEach(function (selectedSwatch) {
          selectedSwatch.textContent = swatch.getAttribute('data-tooltip');
        });
      });
    });

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail.variant;

      shadeSelector.querySelectorAll('.ColorSwatch__Radio').forEach(function (radio) {
        radio.checked = radio.value === variant.title;
      });
      document.querySelectorAll(".ProductForm__AddToCart[data-referrer='shade-selector-modal']").forEach(function (button) {
        button.setAttribute('data-variant-id', variant.id);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShadeSelector);
  } else {
    initShadeSelector();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skin-quiz-results"] && !Shopify.designMode) return;
  try {
    function initSkinQuizResults() {
    const loadMutation = () => {
      // Select the node that will be observed for mutations
      const targetNode = document.querySelector('#gWHmwX')?.parentElement;

      if (!targetNode) {
        setTimeout(loadMutation, 100);
        return;
      }

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          document.querySelectorAll('.skin-quiz-results').forEach((result) => {
            result.classList.remove('active');
          });
          setTimeout(loadMutation, 100);
        }
      };
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    };
    loadMutation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkinQuizResults);
  } else {
    initSkinQuizResults();
  }
  } catch(e) { console.error(e); }
})();

})();
